import React, { useState, useRef, useEffect } from "react";
import TransferSenderSelectComponent from "./transferSenderSelect.component";
import { selectLoading } from "modules/notification";
import TransferSenderSelectPanelComponent from "./transferSenderSelectPanel.component";
import { getTransferSenderDropdown } from "modules/stockflow/redux";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep } from "lodash";

function TransferSenderSelectContainer({
  handleChange,
  disabled,
  value,
  styles,
  textStyles,
  placeholder,
}) {
  const isFetching = useSelector((state) =>
    selectLoading(state, getTransferSenderDropdown.typePrefix)
  );
  const transferSenderDropdown = useSelector(
    (state) => state.stockflowTransfer.transferSenderDropdown
  );
  const lang = useSelector((state) => state.constant.languages);
  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTransferSenderDropdown({ search }));
  }, [search, dispatch]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  useEffect(() => {
    setSelectAll(value.length === transferSenderDropdown.length);
  }, [value, transferSenderDropdown]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleSelectAll = async () => {
    if (!selectAll) {
      let selectedSender = transferSenderDropdown.map((p) => {
        return p.uuid;
      });
      handleChange(selectedSender);
    } else {
      handleChange([]);
    }
  };

  const handleSelectSender = (sender) => {
    let temp = cloneDeep(value);

    if (temp.findIndex((t) => t === sender.uuid) >= 0) {
      temp = temp.filter((t) => t !== sender.uuid);
    } else {
      temp.push(sender.uuid);
    }
    handleChange(temp);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <>
      <TransferSenderSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <TransferSenderSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isFetching}
        transferSenderDropdown={transferSenderDropdown}
        handleSelectAll={handleSelectAll}
        handleSelectSender={handleSelectSender}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  );
}

export default TransferSenderSelectContainer;
